import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";

const LocationAutocomplete = ({
  queryType = "city",
  title,
  value,
  onChange,
  error,
  disable,
  placeholder = "Search...",
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  // const [error, setError] = useState("");

  const handleInputChange = (event, newInputValue) => {
    onChange(newInputValue);
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    const newTimeout = setTimeout(() => {
      if (newInputValue) {
        fetchLocations(newInputValue);
      } else {
        setOptions([]);
      }
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const fetchLocations = async (query) => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${query}&addressdetails=1&limit=5`
      );
      const data = await response.json();
      const filteredData = data.filter(
        (item) => item.addresstype === queryType
      );

      const selectedFields = filteredData.map((item) => ({
        lat: item.lat,
        lon: item.lon,
        addresstype: item.addresstype,
        name: item.name,
        display_name: item.display_name,
      }));
      setOptions(selectedFields);
      setLoading(false);
    } catch (error) {
      // setError("Error fetching locations. Please try again.");
      setLoading(false);
    }
  };

  const handleSelectionChange = (event, newValue) => {
    if (!newValue) {
      // setError("Please select a valid location.");
      onChange("");
    } else {
      // setError("");
      onChange(newValue);
    }
  };

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "bold",
          mt: "1rem",
        }}
      >
        {title}
      </Typography>
      <Autocomplete
        freeSolo
        // options={options}
        options={options || []}
        disabled={disable}
        getOptionLabel={(option) =>
          typeof option === "string"
            ? option
            : option.name || option.display_name || ""
        }
        filterOptions={(x) => x}
        onInputChange={handleInputChange}
        onChange={handleSelectionChange}
        size="small"
        inputValue={value}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="outlined"
            placeholder={placeholder}
            error={!!error}
            helperText={
              error && (
                <Typography
                  variant="body2"
                  color="error"
                  style={{
                    marginLeft: "-12px",
                    marginTop:"-5px"
                  }}
                >
                  {error}
                </Typography>
              )
            }
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default LocationAutocomplete;
